<template>
  <admin-page-frame>
    <el-form v-loading="loading" label-width="120px" size="small" style="max-width: 560px;">
      <el-form-item label="机构名称"><el-input v-model="form.orgName" maxlength="128" /></el-form-item>
      <el-form-item label="机构编码"><el-input v-model="form.orgCode" disabled /></el-form-item>
      <el-form-item label="联系电话"><el-input v-model="form.contactPhone" maxlength="32" /></el-form-item>
      <el-form-item label="联系地址"><el-input v-model="form.contactAddress" maxlength="256" /></el-form-item>
      <el-form-item label="请假规则"><el-tag type="success" size="small">请假不扣课（Phase 1 固定）</el-tag></el-form-item>
      <el-form-item label="收费方式"><el-tag type="warning" size="small">仅线下收费</el-tag></el-form-item>
      <el-form-item><el-button type="primary" :loading="saving" @click="handleSave">保存</el-button></el-form-item>
    </el-form>
  </admin-page-frame>
</template>
<script>
import AdminPageFrame from './components/AdminPageFrame.vue'
import { fetchSchoolOrgSetting, saveSchoolOrgSetting } from '@/api/h5-admin-schools'
import './schools-admin.less'
export default {
  name: 'SchoolsSetting', components: { AdminPageFrame },
  data() { return { loading: false, saving: false, form: { orgCode: '', orgName: '', contactPhone: '', contactAddress: '' } } },
  created() { this.loadSetting() },
  methods: {
    loadSetting() { this.loading = true; fetchSchoolOrgSetting().then(res => { const org = (res && res.org) || {}; this.form = { orgCode: org.orgCode || '', orgName: org.orgName || '', contactPhone: org.contactPhone || '', contactAddress: org.contactAddress || '' } }).finally(() => { this.loading = false }) },
    handleSave() { this.saving = true; saveSchoolOrgSetting(this.form).then(() => { this.$message.success('保存成功'); this.loadSetting() }).finally(() => { this.saving = false }) }
  }
}
</script>